// extracted by mini-css-extract-plugin
export default {"CreateVersionProgressModal-content":"CreateVersionProgressModal-content1VLMJ7Ow4vg1"};